import { useLazyQuery } from '@apollo/client/react';

import {
  ChatType,
  ChatTypeFilter,
  CrmType,
  GetCustomerListWithTagQuery,
  GetCustomerListWithTagQueryVariables,
} from '@anyx/common-graphql';


import { GET_CUSTOMER_LIST_WITH_TAG } from '../graphql';

interface TestStaffListSharedProps {
  storeId: string;
}

const ONE_WEEK = 7;

const sharedVariables: Pick<
  GetCustomerListWithTagQueryVariables,
  'chatTypeFilter' | 'offset' | 'limit' | 'tagFilter'
> = {
  chatTypeFilter: ChatTypeFilter.ALL,
  offset: 0,
  limit: 50,
  tagFilter: { tagName: 'Staff', tagSource: CrmType.COMMERCIAL }, // This is fixed on BE for testing user
};

function useTestStaffList(variables: GetCustomerListWithTagQueryVariables) {
  const [getCustomerListWithTag] = useLazyQuery<
    GetCustomerListWithTagQuery,
    GetCustomerListWithTagQueryVariables
  >(GET_CUSTOMER_LIST_WITH_TAG, {
    fetchPolicy: 'no-cache',
  });

  const getTestStaffList = async () => {
    try {
      const { data, error } = await getCustomerListWithTag({ variables });

      if (error) throw error;

      if (!data?.Chats?.chats) return [];

      return data.Chats.chats.map(({ id, userName, avatar }) => ({
        id,
        name: userName,
        avatar,
      }));
    } catch (error) {
      return [];
    }
  };

  return {
    getTestStaffList,
  };
}

export function useLineTestStaffList({ storeId }: TestStaffListSharedProps) {
  const LINEVariables: GetCustomerListWithTagQueryVariables = {
    storeId: storeId,
    messagingChannel: ChatType.LINE,
    ...sharedVariables,
  };

  const { getTestStaffList } = useTestStaffList(LINEVariables);

  return {
    getTestStaffList,
  };
}

export function useMessengerTestStaffList({ storeId }: TestStaffListSharedProps) {
  const MessengerVariables: GetCustomerListWithTagQueryVariables = {
    storeId: storeId,
    messagingChannel: ChatType.MESSENGER,
    daysSinceLastReceivedMessageWithIn: ONE_WEEK,
    ...sharedVariables,
  };

  const { getTestStaffList } = useTestStaffList(MessengerVariables);

  return {
    getTestStaffList,
  };
}
